<div class="md-form md-outline">
  <input
    [id]="id"
    [ngModel]="displayValue"
    (ngModelChange)="handleInput($event)"
    [name]="name"
    [mdbAutoCompleter]="auto"
    (clearBtnClicked)="handleClear()"
    [placeholder]="'components.inputs.country.placeholder' | translate"
    [class.ng-invalid]="control.invalid"
    [class.ng-valid]="control.valid"
    [class.ng-touched]="control.touched"
    [class.ng-pristine]="control.pristine"
    [class.ng-untouched]="control.untouched"
    [class.ng-dirty]="control.dirty"
    [mdbValidate]="true"
    [validateSuccess]="false"
    type="text"
    class="form-control completer-input mdb-autocomplete mb-0"
    mdbInput
    [autocomplete]="'off'"
    jhiMarkAsterisk
  />
  <label [for]="id" *ngIf="label">{{ label }}</label>
  <mdb-error *ngIf="control && control.invalid && (control.dirty || control.touched)">
    <span *ngIf="control.hasError('required')" jhiTranslate="ERROR.REQUIRED_FIELD"></span>
  </mdb-error>
  <mdb-auto-completer (selected)="handleSelect($event)" #auto="mdbAutoCompleter" [textNoResults]="getMessage()">
    <mdb-option *ngFor="let option of results | async" [value]="option.countryCode!">
      {{ option.translationKey | translate }}
    </mdb-option>
  </mdb-auto-completer>
</div>
